// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5d2ebabc] #birthday__value_ {\n  color: #ff7a37 !important;\n}\n[data-v-5d2ebabc] #birthday__outer_ {\n  background: transparent !important;\n}\n", ""]);
// Exports
module.exports = exports;
